















import { Vue, Component, Prop } from 'nuxt-property-decorator';
import UniversalSearchResultsPortfolio from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsPortfolio.vue';
import UniversalSearchResultsUser from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsUser.vue';
import UniversalSearchResultsCompany from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsCompany.vue';
import UniversalSearchResultsPost from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsPost/UniversalSearchResultsPost.vue';
import UniversalSearchResultsArticle from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsArticle.vue';
import UniversalSearchResultsItem from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsItem.vue';
import { buildSearchItemData } from '@/components/common/UniversalSearch/utils';
import type { UniversalSearchResult, UniversalSearchResultItem } from '@/components/common/UniversalSearch/types';

const renderMap: Map<UniversalSearchResultItem['category'], string> = new Map([
  ['user_portfolios', 'UniversalSearchResultsPortfolio'],
  ['wr_users', 'UniversalSearchResultsUser'],
  ['companies', 'UniversalSearchResultsCompany'],
  ['wr_posts', 'UniversalSearchResultsPost'],
  ['academy_articles', 'UniversalSearchResultsArticle'],
]);

@Component<UniversalSearchResults>({
  components: {
    UniversalSearchResultsItem,
    UniversalSearchResultsPortfolio,
    UniversalSearchResultsUser,
    UniversalSearchResultsCompany,
    UniversalSearchResultsPost,
    UniversalSearchResultsArticle,
  },
})
export default class UniversalSearchResults extends Vue {
  @Prop({ required: true }) results!: UniversalSearchResult[];
  @Prop({ default: false }) removable!: boolean;

  get items() {
    return this.results
      .flatMap(result =>
        result.items.map(item => {
          const searchItem = buildSearchItemData(item);
          return {
            component: renderMap.get(item.category),
            item,
            key: `${searchItem?.category}-${searchItem?.id}-${item.queryId ?? ''}`,
          };
        }),
      )
      .filter(item => Boolean(item.component));
  }

  handleOpen(item: UniversalSearchResultItem, additionalData: { willOpen?: boolean }) {
    this.$emit('open', item, false, additionalData.willOpen !== false);
  }
}
